// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-filter-menu_category_and_filter_box_section__fsBri {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.category-filter-menu_category_and_filter_box__HeVBc {
    width: 100%;
    height: 32px;
    max-width: 350px;
    overflow: hidden;
    margin-top: 130px;
    border-radius: 50px;
    background-color: #24261F;
}
.category-filter-menu_category_and_filter_box__HeVBc > div {
    height: 28px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border-radius: 50px;
    justify-content: center;
}
.category-filter-menu_category_and_filter_box__HeVBc div p {
    margin: 0%;
    font-size: 12px;
    color: #CDCDCD;
    font-family: "Gothic";
}

.category-filter-menu_category_box__nbGHd {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    width: 48.8% !important;
    border: 2px solid #D6E5B8;
}
.category-filter-menu_category_box__nbGHd div {
    width: 12px;
    height: 12px;
    margin-left: 5px;
    transform: rotate(180deg);
    background-color: #85995C;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.category-filter-menu_desktop_info_text__XY4Ut {
    display: none !important;
}

@media (min-width: 1200px) {
    .category-filter-menu_category_and_filter_box__HeVBc {
        height: 80px;
        margin-top: 165px;
        max-width: 1340px;
        border-radius: 100px;
        border: 1px solid #D6E5B8;
    }
    .category-filter-menu_category_and_filter_box__HeVBc > div {
        float: left;
        height: 80px;
        border-radius: 100px;
        width: 33.33% !important;
    }
    .category-filter-menu_category_and_filter_box__HeVBc div p {
        margin: 0%;
        font-size: 20px;
    }
    .category-filter-menu_category_box__nbGHd {
        width: 49.4% !important;
        border: none;
    }
    .category-filter-menu_category_box__nbGHd div {
        width: 20px;
        height: 20px;
    }

    .category-filter-menu_desktop_info_text__XY4Ut {
        font-weight: bold !important;
        display: flex !important;
        color: red;
    }
    .category-filter-menu_desktop_info_text__XY4Ut p {
        font-weight: bold;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/category-filter-menu/category-filter-menu.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;QACpB,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,4BAA4B;QAC5B,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".category_and_filter_box_section {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.category_and_filter_box {\r\n    width: 100%;\r\n    height: 32px;\r\n    max-width: 350px;\r\n    overflow: hidden;\r\n    margin-top: 130px;\r\n    border-radius: 50px;\r\n    background-color: #24261F;\r\n}\r\n.category_and_filter_box > div {\r\n    height: 28px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    border-radius: 50px;\r\n    justify-content: center;\r\n}\r\n.category_and_filter_box div p {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    color: #CDCDCD;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.category_box {\r\n    cursor: pointer;\r\n    user-select: none;\r\n    width: 48.8% !important;\r\n    border: 2px solid #D6E5B8;\r\n}\r\n.category_box div {\r\n    width: 12px;\r\n    height: 12px;\r\n    margin-left: 5px;\r\n    transform: rotate(180deg);\r\n    background-color: #85995C;\r\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n}\r\n\r\n.desktop_info_text {\r\n    display: none !important;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .category_and_filter_box {\r\n        height: 80px;\r\n        margin-top: 165px;\r\n        max-width: 1340px;\r\n        border-radius: 100px;\r\n        border: 1px solid #D6E5B8;\r\n    }\r\n    .category_and_filter_box > div {\r\n        float: left;\r\n        height: 80px;\r\n        border-radius: 100px;\r\n        width: 33.33% !important;\r\n    }\r\n    .category_and_filter_box div p {\r\n        margin: 0%;\r\n        font-size: 20px;\r\n    }\r\n    .category_box {\r\n        width: 49.4% !important;\r\n        border: none;\r\n    }\r\n    .category_box div {\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n\r\n    .desktop_info_text {\r\n        font-weight: bold !important;\r\n        display: flex !important;\r\n        color: red;\r\n    }\r\n    .desktop_info_text p {\r\n        font-weight: bold;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category_and_filter_box_section": `category-filter-menu_category_and_filter_box_section__fsBri`,
	"category_and_filter_box": `category-filter-menu_category_and_filter_box__HeVBc`,
	"category_box": `category-filter-menu_category_box__nbGHd`,
	"desktop_info_text": `category-filter-menu_desktop_info_text__XY4Ut`
};
export default ___CSS_LOADER_EXPORT___;
